import arrowsPosition from './arrowsPosition';
import arrowsVerticalPosition from './arrowsVerticalPosition';
import cubeType from './cubeType';
import dimensions from './dimensions';
import events from './events';
import formFactor from './formFactor';
import gallerySizeType from './gallerySizeType';
import galleryTextAlign from './galleryTextAlign.js';
import gridStyle from './gridStyle';
import groupTypes from './groupTypes';
import imageHoverAnimations from './imageHoverAnimations';
import infoBehaviourOnHover from './infoBehaviourOnHover';
import infoType from './infoType';
import isVertical from './isVertical';
import itemClick from './itemClick';
import layout from './layout';
import layoutDirection from './layoutDirection';
import loadingMode from './loadingMode';
import loadingWithColorMode from './loadingWithColorMode';
import loadMoreAmount from './loadMoreAmount';
import mobileSwipeAnimations from './mobileSwipeAnimations';
import overlayAnimations from './overlayAnimations';
import placements, { hasAbovePlacement, hasBelowPlacement, hasHoverPlacement, hasRightPlacement, hasLeftPlacement, hasVerticalPlacement, hasHorizontalPlacement, isAbovePlacement, isBelowPlacement, isHoverPlacement, isRightPlacement, isLeftPlacement, isVerticalPlacement, isHorizontalPlacement, } from './placements';
import resizeMethods from './resizeMethods';
import scrollAnimations from './scrollAnimations';
import slideAnimations from './slideAnimations';
import scrollDirection from './scrollDirection';
import socialNetworks from './socialNetworks';
import textBoxWidthCalculationOptions from './textBoxWidthCalculationOptions';
import thumbnailsAlignment from './thumbnailsAlignment';
import { URL_SIZES as urlSizes, URL_TYPES as urlTypes } from './urlTypes';
import videoPlay from './videoPlay';
import viewMode from './viewMode';
import imagePlacementAnimations from './imagePlacementAnimations';
import slideTransition from './slideTransition';
export default {
    arrowsPosition: arrowsPosition,
    arrowsVerticalPosition: arrowsVerticalPosition,
    cubeType: cubeType,
    dimensions: dimensions,
    events: events,
    formFactor: formFactor,
    gallerySizeType: gallerySizeType,
    galleryTextAlign: galleryTextAlign,
    gridStyle: gridStyle,
    groupTypes: groupTypes,
    imageHoverAnimations: imageHoverAnimations,
    infoBehaviourOnHover: infoBehaviourOnHover,
    infoType: infoType,
    isVertical: isVertical,
    itemClick: itemClick,
    layout: layout,
    layoutDirection: layoutDirection,
    loadingMode: loadingMode,
    loadingWithColorMode: loadingWithColorMode,
    loadMoreAmount: loadMoreAmount,
    mobileSwipeAnimations: mobileSwipeAnimations,
    overlayAnimations: overlayAnimations,
    placements: placements,
    hasAbovePlacement: hasAbovePlacement,
    hasBelowPlacement: hasBelowPlacement,
    hasHoverPlacement: hasHoverPlacement,
    hasRightPlacement: hasRightPlacement,
    hasLeftPlacement: hasLeftPlacement,
    hasVerticalPlacement: hasVerticalPlacement,
    hasHorizontalPlacement: hasHorizontalPlacement,
    isAbovePlacement: isAbovePlacement,
    isBelowPlacement: isBelowPlacement,
    isHoverPlacement: isHoverPlacement,
    isRightPlacement: isRightPlacement,
    isLeftPlacement: isLeftPlacement,
    isVerticalPlacement: isVerticalPlacement,
    isHorizontalPlacement: isHorizontalPlacement,
    resizeMethods: resizeMethods,
    scrollAnimations: scrollAnimations,
    slideAnimations: slideAnimations,
    scrollDirection: scrollDirection,
    socialNetworks: socialNetworks,
    textBoxWidthCalculationOptions: textBoxWidthCalculationOptions,
    thumbnailsAlignment: thumbnailsAlignment,
    urlSizes: urlSizes,
    urlTypes: urlTypes,
    videoPlay: videoPlay,
    viewMode: viewMode,
    imagePlacementAnimations: imagePlacementAnimations,
    slideTransition: slideTransition,
};
//# sourceMappingURL=index.js.map